import React, { useState, useEffect } from "react";
import usePermissions from "../../Hooks/hook-permissions";
import Button from "../../UI/Button";

const OnBoard = ({ showGrantButton }) => {
  const [_showGrantButton, setShowGrantButton] = useState(true);

  const { promptPermissionGrant } = usePermissions({
    showInitialPrompt: false,
  });

  useEffect(() => {
    if (typeof showGrantButton === "boolean") {
      setShowGrantButton(showGrantButton);
    }
  }, [showGrantButton]);

  return (
    <div className="w-full h-full sm:bg-gray-800 sm:rounded-2xl p-10 sm:p-24 flex sm:justify-center">
      <div>
        <p className="text-lg sm:text-2xl tracking-wide">
          Required Persissions
        </p>
        <ul className="mt-4 text-lg sm:text-xl list-disc ml-5">
          <li>Audio</li>
          <li>Video</li>
        </ul>
        {_showGrantButton && (
          <Button
            className="mt-6 bg-green-500"
            onClick={() => promptPermissionGrant()}
          >
            Grant Access
          </Button>
        )}
        {!_showGrantButton && (
          <p className="mt-4 text-lg sm:text-xl text-red-400">
            Note: You have a permission blocked by your browser. We need both
            audio and video to continue. Please allow it from the site
            information icon in the search bar.
          </p>
        )}
      </div>
    </div>
  );
};

export default OnBoard;
